import React from 'react';
import { motion } from 'framer-motion';

export default function Header() {
  return (
    <motion.header 
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="w-full py-8 md:py-12 flex justify-between items-center"
    >
      <div className="text-xl md:text-2xl font-extrabold tracking-tighter text-navy uppercase">
        Veric
      </div>
    </motion.header>
  );
}